import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BaseComponent} from "../../../../../../base/components/base.component";
import * as moment from "moment";
import {EventBusService} from "../../../../../../base/services/eventbus/event-bus.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../../../base/services/subscription-container.service";
import {TimeUtility} from "../../time.utility";
import {BasicFilterData, defaultFilterData, FilterField, parseFilterData} from "./basic-filter.model";
import {AuthService} from "../../../auth/services/auth.service";
import {convertDateFieldsToISO, IParams} from "../../../../../../base/endpoints/iparams";

@Component({
  selector: 'app-basic-filter',
  templateUrl: './basic-filter.component.html',
  styleUrls: ['./basic-filter.component.scss']
})
export class BasicFilterComponent extends BaseComponent {

  @Input() useParamNavigation: boolean = true

  @Input() showAddBtn: boolean = true
  @Input() addBtnText: string = "Add"
  @Input() addButtonRoute: string | null = null
  @Input() extraFields: FilterField[] = []

  @Output() filterClick: EventEmitter<BasicFilterData> = new EventEmitter<BasicFilterData>()
  @Output() addButtonClick: EventEmitter<void> = new EventEmitter<void>()

  filterData: BasicFilterData = defaultFilterData
  isAdmin: boolean = false

  constructor(eventBus: EventBusService,
              router: Router,
              subContainer: SubscriptionContainerService,
              protected activatedRoute: ActivatedRoute,
              private authService: AuthService) {
    super(eventBus, router, subContainer)

    this.authService.isAdminAsync().subscribe(value => this.isAdmin = value)
  }

  protected componentName(): string {
    return BasicFilterComponent.name;
  }

  ngOnInit(): void {
    // initialize extra filter fields
    setTimeout(() => {
      this.filterData.extra = this.filterFieldsAsParams()
    }, 100)

    if (this.useParamNavigation) {
      this.activatedRoute.queryParams.subscribe(params => {
        if (this.filterData.fromDate != null && this.filterData.toDate != null) {
          this.filterData.fromDate = moment(this.filterData.fromDate).toDate();
          this.filterData.toDate = moment(this.filterData.toDate).toDate();
        } else {
          this.filterData.fromDate = new Date(0)
          this.filterData.toDate = new Date()
        }

        // initialize extra filter fields from query params
        let existingValues = this.filterFieldsAsParams()
        this.filterData = parseFilterData(params, 10, existingValues)

      });
    }

  }

  filterFieldsAsParams(): IParams {
    return Object.fromEntries(
      this.extraFields.map((field) => {
        return [field.name, field.value]
      })
    )
  }

  onFilterClick() {
    if (!this.useParamNavigation) {
      this.filterClick.emit(this.filterData)
    } else {
      this.router.navigate(['.'], {
        relativeTo: this.activatedRoute,
        queryParams: {
          username: this.filterData.username,
          query: this.filterData.query,
          from_date: this.filterData.fromDate.toISOString(),
          to_date: this.filterData.toDate.toISOString(),
          page: this.filterData.page,
          size: this.filterData.size,
          ...convertDateFieldsToISO(this.filterData.extra)
        },
        queryParamsHandling: 'merge',
      }).then(r => {
      });
    }
  }

  onAddButtonClick() {
    this.addButtonClick.emit()
  }

  filterForToday() {
    this.filterData.fromDate = TimeUtility.getDayStart(new Date())
    this.filterData.toDate = TimeUtility.getDayEnd(new Date())
    this.onFilterClick()
  }

  filterForYesterday() {
    this.filterData.fromDate = TimeUtility.getDayStart(TimeUtility.addDays(new Date(), -1))
    this.filterData.toDate = TimeUtility.getDayEnd(TimeUtility.addDays(new Date(), -1))
    this.onFilterClick()
  }

  filterForLast7Days() {
    this.filterData.fromDate = TimeUtility.last7DaysRange(new Date()).start
    this.filterData.toDate = TimeUtility.last7DaysRange(new Date()).end
    this.onFilterClick()
  }

  filterForThisMonth() {
    this.filterData.fromDate = TimeUtility.monthRange(new Date()).start
    this.filterData.toDate = TimeUtility.monthRange(new Date()).end

    this.onFilterClick()
  }

  filterForLastMonth() {
    this.filterData.fromDate = TimeUtility.monthRange(TimeUtility.addMonths(new Date(), -1)).start
    this.filterData.toDate = TimeUtility.monthRange(TimeUtility.addMonths(new Date(), -1)).end

    this.onFilterClick()
  }

  filterForThisYear() {
    this.filterData.fromDate = TimeUtility.yearRange(new Date()).start
    this.filterData.toDate = TimeUtility.yearRange(new Date()).end

    this.onFilterClick()
  }

  filterForLastYear() {
    this.filterData.fromDate = TimeUtility.yearRange(TimeUtility.addYears(new Date(), -1)).start
    this.filterData.toDate = TimeUtility.yearRange(TimeUtility.addYears(new Date(), -1)).end

    this.onFilterClick()
  }

  clearFilter() {
    this.filterData.query = null
    this.filterData.username = null
    this.filterData.fromDate = TimeUtility.getDayStart(new Date(0))
    this.filterData.toDate = TimeUtility.getDayEnd(new Date())
    this.filterData.page = 0
    this.filterData.size = 10
    this.filterData.extra = this.filterFieldsAsParams()
    this.onFilterClick()
  }

  onFilterOptionSelected(key: string, value: string | number | Date | boolean) {
    this.filterData.extra[key] = value
  }

  getSelectedLabel(ff: FilterField) {
    let filterValue = this.filterData.extra[ff.name]
    if (filterValue == null || filterValue == '') return ff.placeholder
    else return ff.options?.find(o => {
      return o.value === filterValue
    })?.label
  }
}
